import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { FaTasks, FaMobileAlt, FaLock, FaArrowRight, FaShieldAlt, FaChartLine } from 'react-icons/fa';

const Login = () => {
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await login(mobile, password);
        setLoading(false);
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
            {/* Animated Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-600 via-blue-600 to-indigo-700">
                <div className="absolute inset-0 bg-black opacity-20"></div>
                <div className="absolute top-20 left-10 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
                <div className="absolute bottom-20 right-10 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-indigo-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-500"></div>
            </div>

            {/* Login Card */}
            <div className="relative z-10 w-full max-w-md animate-fade-in-up">
                <div className="glass-card p-8">
                    {/* Logo Section */}
                    <div className="text-center mb-8">
                        <div className="inline-block">
                            <div className="bg-gradient-to-br from-purple-500 to-pink-500 p-4 rounded-2xl shadow-lg mb-4 transform transition-transform hover:scale-105 duration-300">
                                <FaTasks className="text-white text-4xl" />
                            </div>
                        </div>
                        <h1 className="text-4xl font-bold gradient-text mb-2">TaskFlow</h1>
                        <p className="text-gray-600">Smart Task Management System</p>
                    </div>

                    {/* Features Badges */}
                    <div className="flex justify-center space-x-3 mb-8">
                        <div className="flex items-center space-x-1 bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-xs font-semibold">
                            <FaShieldAlt className="text-xs" />
                            <span>Secure</span>
                        </div>
                        <div className="flex items-center space-x-1 bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs font-semibold">
                            <FaChartLine className="text-xs" />
                            <span>Analytics</span>
                        </div>
                        <div className="flex items-center space-x-1 bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold">
                            <FaTasks className="text-xs" />
                            <span>Real-time</span>
                        </div>
                    </div>

                    {/* Login Form */}
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label className="block text-gray-700 text-sm font-semibold mb-2">
                                <FaMobileAlt className="inline mr-2 text-purple-500" />
                                Mobile Number
                            </label>
                            <div className="relative group">
                                <input
                                    type="tel"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                    className="input-modern"
                                    placeholder="Enter 10-digit mobile number"
                                    required
                                    pattern="[0-9]{10}"
                                />
                                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                    <div className="text-xs text-gray-400">+91</div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label className="block text-gray-700 text-sm font-semibold mb-2">
                                <FaLock className="inline mr-2 text-purple-500" />
                                Password
                            </label>
                            <div className="relative">
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="input-modern"
                                    placeholder="Enter password"
                                    required
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="btn-gradient w-full text-white py-3 rounded-xl font-semibold text-lg transition-all flex items-center justify-center gap-2 group"
                        >
                            {loading ? (
                                <>
                                    <div className="loader w-5 h-5 border-2"></div>
                                    <span>Logging in...</span>
                                </>
                            ) : (
                                <>
                                    <span>Login to Dashboard</span>
                                    <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                                </>
                            )}
                        </button>
                    </form>

                    {/* Demo Credentials */}
                    <div className="mt-8 pt-6 border-t border-gray-200">
                        <p className="text-center text-sm text-gray-500 mb-3 font-semibold">
                            Demo Credentials
                        </p>
                        <div className="grid grid-cols-2 gap-3 text-xs">
                            <div className="bg-purple-50 rounded-lg p-2 text-center">
                                <p className="font-semibold text-purple-700">Admin</p>
                                <p className="text-gray-600">9999999999</p>
                                <p className="text-gray-500">admin123</p>
                            </div>
                            <div className="bg-blue-50 rounded-lg p-2 text-center">
                                <p className="font-semibold text-blue-700">User</p>
                                <p className="text-gray-600">9876543210</p>
                                <p className="text-gray-500">admin123</p>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="mt-6 text-center">
                        <p className="text-xs text-gray-400">
                            © 2024 TaskFlow. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;